module.exports = __webpack_public_path__ + "static/media/yogesh.70693360.jpg";